import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

export const getDashboard = (filter) => {
  console.log("Filter in request is " + filter)
  return axios.get(`${CoreService.getPrivateURL()}dashboard`);
};


const DashboardService = {
  getDashboard,
};
export default DashboardService;
